import validate from 'validate.js'
import querystring from 'querystring'

/**
 * Lists an array of objects in object notation. It is recommended to use a unique key because identical keys will not be duplicated.
 * @param {Array.<Object>}
 * @param {String} key Key by which array of identical objects should be listed.
 * @returns {Object} Transformed object
 */
export const indexArrayBy = (array, key) => {
  if (!validate.isArray(array)) {
    throw new TypeError(`Function "indexArrayBy" expected param "array" of type Array, but got ${typeof id}`)
  }

  if (!validate.isDefined(key) || !validate.isString(key)) {
    throw new TypeError(`Function "indexArrayBy" expected param "key" of type String, but got ${typeof id}`)
  }

  return array.reduce((acc, cur, index) => {
    if (!validate.isDefined(cur[key])) {
      throw new Error(`[indexArrayBy]: Key "${key}" does not exist in the object at index "${index}"`)
    }
    if (validate.isDefined(acc[cur[key]])) {
      console.warn(`[indexArrayBy]: Key provided "${key}" is not a unique. Will overwrite previously set values.`)
    }
    acc[cur[key]] = cur
    return acc
  }, {})
}

/**
 * @description Converts an object into url query params.
 * @param {object} object
 * @returns {'string'} - Query String
 */
export function objectToUrlParams (object) {
  const queryString = querystring.encode(object)
  return queryString
}
